import { Component } from '@angular/core';
import { IconComponent } from '../../shared';
import { DIFFERENTIATORS } from '../../content/home.content';

@Component({
  selector: 'app-governance',
  imports: [IconComponent],
  templateUrl: './governance.component.html'
})
export class GovernanceComponent {
  readonly content = DIFFERENTIATORS;
}
